import {Notice, NoticeEntity} from "../../../model/notice";
import {makeEntitySelectors} from "../base-entity-store";

export interface NoticeSelectorProps {

}

const noticeSelectors = makeEntitySelectors<
  Notice,
  NoticeEntity,
  NoticeSelectorProps
>({
  defaultProps: {},

  filter: (_v, _props) => true,

  transform: (value) => NoticeEntity.from(value),
});

export const noticesSelector =
  (props?: NoticeSelectorProps) =>
    noticeSelectors.listSelector(props);

export const noticeSelector =
  () => noticeSelectors.singleSelector();
